import {
  Box,
  Tab,
  TableCell,
  TableRow,
  Typography,
  styled,
} from "@mui/material"

export const DrawerBox = styled(Box)({
  width: "600px",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  top: "90px",
})

export const DrawerBoxHeading = styled(Box)({
  width: "100%",
  height: "50px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: 1,
  borderColor: "divider",
  padding: "0px 40px",
})
export const Heading = styled(Box)({
  width: "100%",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
})
export const TypoHeading = styled(Typography)({
  fontSize: "16px",
  fontWeight: "bold",
})

export const ModalHeadingRow = styled(TableRow)({
  backgroundColor: "#3366D6",
  height: "32px",
  position: "sticky",
  top: "0px",
  textAlign: "center",
})

export const ModalHeadingCell = styled(TableCell)({
  color: "#fff",
  fontSize: "13px",
})
export const StyledTab = styled((props: any) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  //fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(16),
  //marginLeft: theme.typography.pxToRem(26),
  paddingLeft: 0,
  color: "#707070",
  "&.Mui-selected": {
    color: "#000",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#3C77EF",
  },
}))
